var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.53,
    height: 9.599,
    viewBox: "0 0 9.53 9.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter_alt_black_18dp",
    transform: "translate(-3.23 -3.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33875",
    "data-name": "Path 33875",
    d: "M4.165,4.966C5.375,6.52,7.609,9.4,7.609,9.4V13a.6.6,0,0,0,.6.6h1.2A.6.6,0,0,0,10,13V9.4s2.228-2.88,3.438-4.434A.6.6,0,0,0,12.968,4H4.638A.6.6,0,0,0,4.165,4.966Z",
    transform: "translate(-0.808 -0.8)",
    fill: "#002D62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c3c07e029e5fbf7d3cf5166361e8887e.svg";
export { ForwardRef as ReactComponent };